<template>
  <div class="index_Info">
    <div class="box1">
      <div class="box1_left">
        <div class="box1_left_top">
          <div class="box1_left_top_text1">{{real_time_data.name}}</div>
          <div class="box1_left_top_text2">{{real_time_data.codes}}</div>
          <div class="box1_left_top_text3">有色金属</div>
          <div class="box1_left_top_text4">证券11</div>
          <div class="box1_left_top_text5">
            （{{real_time_data.tradeDate || '--'}} {{real_time_data.tradeTime || '--'}}） 交易状态:交易中
          </div>
        </div>
        <div class="box1_left_bottom">
          <div class="box1_left_bottom_left">
            <div class="box1_left_bottom_left_text1">{{real_time_data.lastest_price || '--'}}</div>
            <div class="box1_left_bottom_left_text2">{{real_time_data.change || '--'}}  &nbsp;&nbsp; {{real_time_data.change_ratio || '--'}}%</div>
          </div>
          <div class="box1_left_bottom_right">
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">
                最高：<i style="font-style: normal; color: #fd4c4c">{{real_time_data.high || '--'}}</i>
              </div>
              <div class="box1_left_bottom_right_text1">
                最低：<i style="font-style: normal; color: #47ba74">{{real_time_data.low || '--'}}</i>
              </div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">
                今开：<i style="font-style: normal; color: #fd4c4c">{{real_time_data.open || '--'}}</i>
              </div>
              <div class="box1_left_bottom_right_text1">昨收：{{real_time_data.preClose || '--'}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">成交量：{{real_time_data.volume || '--'}}</div>
              <div class="box1_left_bottom_right_text1">成交额：{{real_time_data.amount || '--'}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">换手率：</div>
              <div class="box1_left_bottom_right_text1">振幅：{{real_time_data.swing || '--'}}%</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">市盈(静)：</div>
              <div class="box1_left_bottom_right_text1">市盈(TTM)：</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">每股收益：</div>
              <div class="box1_left_bottom_right_text1">每股净资产：</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">流通股本：</div>
              <div class="box1_left_bottom_right_text1">
                流通市值：
              </div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">总市值：{{real_time_data.totalCapital_index || '--'}}</div>
              <div class="box1_left_bottom_right_text1">市净值：</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box1_right">
        <div class="box1_right_top"><img style="width: 12px;height: 12px;vertical-align: middle;margin-right: 2px;" src="../../../public/img/shares_Info/add.png"/>添加自选</div>
        <div class="box1_right_bottom">
          <div class="box1_right_bottom_left"><img style=" width:14px;height:14px;vertical-align:middle;margin-right:2px;" src="../../../public/img/shares_Info/contrast.png"/>股票对比</div>
          <div class="box1_right_bottom_right" @click="frame1_open">指数简介</div>
        </div>
      </div>
    </div>

    <div class="box2">
      <div class="box2_top_button">
        <div class="box2_top_button_text1" :class="{ box2_top_button_text2: change_option == 0 }" @click="change_change_option(0)">日k</div>
        <div class="box2_top_button_text1" :class="{ box2_top_button_text2: change_option == 1 }" @click="change_change_option(1)">周k</div>
        <div class="box2_top_button_text1" :class="{ box2_top_button_text2: change_option == 2 }" @click="change_change_option(2)">月k</div>
        <div class="box2_top_button_text1" :class="{ box2_top_button_text2: change_option == 3 }" @click="change_change_option(3)">年k</div>
      </div>
      <Chart1 :chart1_data_x='chart1_data_x' :chart1_data_y='chart1_data_y' :chart1_data_volumes='chart1_data_volumes' ref="chart1"></Chart1>
    </div>

    <div class="box5">
      <div class="box5_top_title" style="margin-bottom:24px;">成分股</div>
      <div class="box5_table">
        <div v-if="bxjj_navigation == 0">
          <el-table :data="tableData" border style="width: 100%" header-row-class-name="back_hui">
            <el-table-column type='index' label="序号" align="center" width='240'>
            </el-table-column>
            <el-table-column prop="codes" label="代码" align="center" min-width='280'>
              <template slot-scope="scope">
                <div @click="gotosharesinfo(scope.row.codes)">{{scope.row.codes}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="ths_stock_short_name_stock" label="股票名称" align="center" min-width='280'>
              <template slot-scope="scope">
                <div @click="gotosharesinfo(scope.row.codes)">{{scope.row.ths_stock_short_name_stock}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="change_ratio" label="涨跌幅" align="center" min-width='280'>
              <template slot-scope="scope">
                <div :class="{'color_red':scope.row.change_ratio > 0,'color_green':scope.row.change_ratio < 0}" @click="gotosharesinfo(scope.row.codes)">
                {{scope.row.change_ratio}}%
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="weight_ratio" label="权重占比" align="center" min-width='280'>
               <template slot-scope="scope">
                <div @click="gotosharesinfo(scope.row.codes)">{{scope.row.weight_ratio}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else style="text-align: center; height: 273px">
          <img src="../../../public/img/shares_Info/null.png" style="vertical-align: middle; width: 223px; margin-top: 50px"/>
          <div style="height: 15px;font-size: 14px;line-height: 15px;color: #999999;margin-top: 15px;">暂无数据</div>
        </div>
      </div>
      <div class="box5_bottom" v-if="bxjj_navigation == 0">
        <div style="margin: 0 auto; width: 90px; cursor: pointer">展开更多<img src="../../../public/img/shares_Info/xiala_bottom.png" alt="" /></div>
      </div>
    </div>

    <div class="box5">
      <div class="box5_top_title" style="margin-bottom:24px;">相关基金</div>
      <div class="box5_table">
        <div v-if="bxjj_navigation == 0">
          <el-table :data="indexRelationFundlist" border style="width: 100%" header-row-class-name="back_hui">
            <el-table-column type='index' label="序号" align="center" width='240'></el-table-column>
            <el-table-column prop="codes" label="代码" align="center" min-width='300'></el-table-column>
            <el-table-column prop="ths_fund_short_name_fund" label="基金名称" align="center" min-width='300'></el-table-column>
            <el-table-column prop="ths_yeild_1y_fund" label="近一年涨跌幅" align="center" min-width='300'>
              <template slot-scope="scope">
                <div :class="{'color_red':scope.row.ths_yeild_1y_fund > 0,'color_green':scope.row.ths_yeild_1y_fund < 0}">
                {{scope.row.ths_yeild_1y_fund || '--'}}%
                </div>
              </template>
            </el-table-column>
            
          </el-table>
        </div>
        <div v-else style="text-align: center; height: 273px">
          <img src="../../../public/img/shares_Info/null.png" style="vertical-align: middle; width: 223px; margin-top: 50px"/>
          <div style="height: 15px;font-size: 14px;line-height: 15px;color: #999999;margin-top: 15px;">暂无数据</div>
        </div>
      </div>
    </div>



    <div class="box6">
      <div class="box6_top_title">
        估值与分位
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame2_open"
          />
        </div>
      </div>
      <div class="box6_top_button">
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 0 }"
          @click="change_top_button2(0)"
        >
          市盈率({{chart2_data_1}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 1 }"
          @click="change_top_button2(1)"
        >
          市净率({{chart2_data_2}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 2 }"
          @click="change_top_button2(2)"
        >
          市销率({{chart2_data_3}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 3 }"
          @click="change_top_button2(3)"
        >
          市现率({{chart2_data_4}})
        </div>
        <div
          class="box6_top_button_button1"
          :class="{ box6_top_button_button2: bxjj_navigation2 == 4 }"
          @click="change_top_button2(4)"
        >
          企业倍数(--)
        </div>
      </div>
      <div v-if="chart2_data_x.length > 0">
        <div class="box6_top_tip">
         {{chart2_data_txt}}
        </div>
        <div class="box6_top_legend_box">
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option1_colordiv"></div>
            高估线
          </div>
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option2_colordiv"></div>
            中估线
          </div>
          <div class="box6_top_legend_box_option1">
            <div class="box6_top_legend_box_option3_colordiv"></div>
            低估线
          </div>
        </div>
        <Chart2 ref="chart2"  :chart2_data_y='chart2_data_y' :chart2_data_y2='chart2_data_y2' :chart2_data_y3='chart2_data_y3' :chart2_data_y4='chart2_data_y4' :chart2_data_x="chart2_data_x"></Chart2>
      </div>
      <div v-else style="text-align: center; height: 350px">
        <img
          src="../../../public/img/shares_Info/null.png"
          alt=""
          style="vertical-align: middle; width: 223px; margin-top: 90px"
        />
        <div
          style="
            height: 15px;
            font-size: 14px;
            line-height: 15px;
            color: #999999;
            margin-top: 15px;
          "
        >
          公司上市不满一年，暂不提供估值分位
        </div>
      </div>
    </div>

    <div class="box7">
      <div class="box7_top_title">
        <div class="box7_top_title_text1">PE/PB Band</div>
        <div class="box7_top_title_text2">
          最近10年<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
            alt=""
          />
        </div>
      </div>
      <div class="box7_top_button">
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 0 }"
          @click="change_top_button3(0)"
        >
          市盈率
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 1 }"
          @click="change_top_button3(1)"
        >
          市净率
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 2 }"
          @click="change_top_button3(2)"
        >
          市销率
        </div>
        <div
          class="box7_top_button_button1"
          :class="{ box7_top_button_button2: bxjj_navigation3 == 3 }"
          @click="change_top_button3(3)"
        >
          市现率
        </div>
      </div>
      <div class="box7_top_tip">
        历史：高于近十年54.20%的时间。 行业：高于消费电子行业均值(26.66)。
        若考虑业绩预告，市盈率为负数，本估值法不适用。
      </div>
      <div class="box7_top_legend_box">
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option1_colordiv"></div>
          股价
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option2_colordiv"></div>
          {{chart3_data_1}}
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option3_colordiv"></div>
          {{chart3_data_2}}
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option4_colordiv"></div>
          {{chart3_data_3}}
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option5_colordiv"></div>
          {{chart3_data_4}}
        </div>
        <div class="box7_top_legend_box_option1">
          <div class="box7_top_legend_box_option6_colordiv"></div>
          {{chart3_data_5}}
        </div>
      </div>
      <Chart3 ref="chart3" :chart3_data_x='chart3_data_x' :chart3_data_y='chart3_data_y' :chart3_data_y2='chart3_data_y2' :chart3_data_y3='chart3_data_y3' :chart3_data_y4='chart3_data_y4' :chart3_data_y5='chart3_data_y5' :chart3_data_y6="chart3_data_y6" ></Chart3>
    </div>

    <div class="box25">
      <div class="box25_top_title">
        <div class="box25_top_title_text1">北向资金</div>
      </div>
      <div class="box25_legend">
        <div class="box25_legend_box1">近1日 <i class="color_green">-4.51亿</i></div>
        <div class="box25_legend_box1">近5日 <i class="color_red">73.9亿</i></div>
        <div class="box25_legend_box1">近20日 <i class="color_red">228亿</i></div>
        <div class="box25_legend_box1">近60日 <i class="color_red">930亿</i></div>
      </div>
      <Chart18></Chart18>
    </div>

    <div class="box10">
      <div class="box10_top_title">
        <div class="box10_top_title_text1">盈利能力-回报率</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame11_open"
          />
        </div>
        <div class="box10_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box10_top_button">
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 0 }"
          @click="change_top_button5(0)"
        >
          ROE({{chart6_data_1}}%)
        </div>
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 1 }"
          @click="change_top_button5(1)"
        >
          ROIC({{chart6_data_2}}%)
        </div>
        <div
          class="box10_top_button_button1"
          :class="{ box10_top_button_button2: bxjj_navigation5 == 2 }"
          @click="change_top_button5(2)"
        >
          ROA({{chart6_data_3}}%)
        </div>
      </div>
      <div class="box10_top_legend_box">
        <div class="box10_top_legend_box_option1">
          <div class="box10_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box10_top_legend_box_option1">
          <div class="box10_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart6 ref="chart6" :chart6_data_x='chart6_data_x' :chart6_data_y='chart6_data_y' :chart6_data_y2='chart6_data_y2' :chart6_data_table='chart6_data_table'></Chart6>
    </div>

    <div class="box11">
      <div class="box11_top_title">
        <div class="box11_top_title_text1">盈利能力-利润率</div>
        <div class="box20_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            alt=""
            @click="frame12_open"
          />
        </div>
        <div class="box11_top_title_text2">
          切换对比<img
            style="width: 9px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/qiehuan.png"
            alt=""
          />
        </div>
      </div>
      <div class="box11_top_button">
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 0 }"
          @click="change_top_button6(0)"
        >
          毛利率(26.9%)
        </div>
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 1 }"
          @click="change_top_button6(1)"
        >
          净利率(2.88%)
        </div>
        <div
          class="box11_top_button_button1"
          :class="{ box11_top_button_button2: bxjj_navigation6 == 2 }"
          @click="change_top_button6(2)"
        >
          营业利润率(3.56%)
        </div>
      </div>
      <div class="box11_top_legend_box">
        <div class="box11_top_legend_box_option1">
          <div class="box11_top_legend_box_option1_colordiv"></div>
          格力电器
        </div>
        <div class="box11_top_legend_box_option1">
          <div class="box11_top_legend_box_option2_colordiv"></div>
          白色家电
        </div>
      </div>
      <Chart7 ref="chart7" :chart7_data_x='chart7_data_x' :chart7_data_y='chart7_data_y' :chart7_data_y2='chart7_data_y2' :chart7_data_table='chart7_data_table'></Chart7>
    </div>



    <div class="box21">
      <div class="box21_top_title">
        <div class="box21_top_title_text1">股息率</div>
        <div class="box21_top_title_text3">
          <img
            style="width: 15px; vertical-align: middle; margin-left: 3px"
            src="../../../public/img/shares_Info/yiwen_yellow.png"
            @click="frame21_open"
          />
        </div>
      </div>
      <div class="box21_top_legend_box">
        最新年化股息收益率为<i class="color_red">{{chart16_data_1}}%</i>
      </div>
      <Chart16 ref="chart16" :chart16_data_x='chart16_data_x' :chart16_data_y='chart16_data_y'></Chart16>
    </div>


    <div
      style="width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.3)"
      class="tuceng"
      v-show="
        frame1_show ||
        frame2_show ||
        frame3_show ||
        frame4_show ||
        frame5_show ||
        frame6_show ||
        frame7_show ||
        frame10_show ||
        frame11_show ||
        frame12_show ||
        frame13_show ||
        frame14_show ||
        frame15_show ||
        frame16_show ||
        frame17_show ||
        frame18_show ||
        frame19_show ||
        frame20_show ||
        frame21_show
      "
    ></div>
    <Frame1 v-show="frame1_show" @close_prame1="close_prame1" :intro='intro'></Frame1>
    <Frame2 v-show="frame2_show" @frame2_close="frame2_close"></Frame2>
    <Frame3 v-show="frame3_show"></Frame3>
    <Frame4 v-show="frame4_show"></Frame4>
    <Frame5 v-show="frame5_show"></Frame5>
    <Frame6 v-show="frame6_show"></Frame6>
    <Frame7 v-show="frame7_show"></Frame7>
    <Frame8 v-show="frame8_show" @frame8_close="frame8_close"></Frame8>
    <Frame9 v-show="frame9_show" @frame9_close="frame9_close"></Frame9>
    <Frame10 v-show="frame10_show" @frame10_close="frame10_close"></Frame10>
    <Frame11 v-show="frame11_show" @frame11_close="frame11_close"></Frame11>
    <Frame12 v-show="frame12_show" @frame12_close="frame12_close"></Frame12>
    <Frame13 v-show="frame13_show" @frame13_close="frame13_close"></Frame13>
    <Frame14 v-show="frame14_show" @frame14_close="frame14_close"></Frame14>
    <Frame15 v-show="frame15_show" @frame15_close="frame15_close"></Frame15>
    <Frame16 v-show="frame16_show" @frame16_close="frame16_close"></Frame16>
    <Frame17 v-show="frame17_show" @frame17_close="frame17_close"></Frame17>
    <Frame18 v-show="frame18_show" @frame18_close="frame18_close"></Frame18>
    <Frame19 v-show="frame19_show" @frame19_close="frame19_close"></Frame19>
    <Frame20 v-show="frame20_show" @frame20_close="frame20_close"></Frame20>
    <Frame21 v-show="frame21_show" @frame21_close="frame21_close"></Frame21>
  </div>
</template>

<script>
import {plateIndexDetail,indexComponentList,Kline,indexRelationFund,indexValuation,indexPePbBand,indexCapitalReturn,indexDividendRate,indexProfitMargin} from "../../http/index_info.js"
import Chart1 from "./chart/chart1.vue";
import Chart2 from "./chart/chart2.vue";
import Chart3 from "./chart/chart3.vue";
import Chart6 from "./chart/chart6.vue";
import Chart7 from "./chart/chart7.vue";
import Chart16 from "./chart/chart16.vue";
import Chart18 from "./chart/chart18.vue";
import Frame1 from "./frame/frame1.vue";
import Frame2 from "./frame/frame2.vue";
import Frame3 from "./frame/frame3.vue";
import Frame4 from "./frame/frame4.vue";
import Frame5 from "./frame/frame5.vue";
import Frame6 from "./frame/frame6.vue";
import Frame7 from "./frame/frame7.vue";
import Frame8 from "./frame/frame8.vue";
import Frame9 from "./frame/frame9.vue";
import Frame10 from "./frame/frame10.vue";
import Frame11 from "./frame/frame11.vue";
import Frame12 from "./frame/frame12.vue";
import Frame13 from "./frame/frame13.vue";
import Frame14 from "./frame/frame14.vue";
import Frame15 from "./frame/frame15.vue";
import Frame16 from "./frame/frame16.vue";
import Frame17 from "./frame/frame17.vue";
import Frame18 from "./frame/frame18.vue";
import Frame19 from "./frame/frame19.vue";
import Frame20 from "./frame/frame20.vue";
import Frame21 from "./frame/frame21.vue";
export default {
  data() {
    return {
      change_option: 0, //  k线图 点击样式切换
      bxjj_navigation: 0, //  大事提醒  点击样式切换
      bxjj_navigation2: 0, //  估值与分位  点击样式切换
      bxjj_navigation3: 0, //  PE/PB Band  点击样式切换
      bxjj_navigation4: 0, //  成长能力  点击样式切换
      bxjj_navigation5: 0, //  盈利能力-回报率  点击样式切换
      bxjj_navigation6: 0, //  盈利能力-利润率  点击样式切换
      bxjj_navigation7: 0, //  盈利能力-费用率  点击样式切换
      bxjj_navigation8: 0, //  现金流量  点击样式切换
      bxjj_navigation9: 0, //  主营构成  点击样式切换
      bxjj_navigation10: 0, //  相对强度  点击样式切换
      frame1_show: false,
      frame2_show: false,
      frame3_show: false,
      frame4_show: false,
      frame5_show: false,
      frame6_show: false,
      frame7_show: false,
      frame8_show: true,
      frame9_show: true,
      frame10_show: false,
      frame11_show: false,
      frame12_show: false,
      frame13_show: false,
      frame14_show: false,
      frame15_show: false,
      frame16_show: false,
      frame17_show: false,
      frame18_show: false,
      frame19_show: false,
      frame20_show: false,
      frame21_show: false,
      box3_show: false,
      box4_show: false,
      box5_null: false,
      tableData: [],  //成分股
      tableData6: [
        {
          data: "1",
          data1: "600519",
          data2: "国泰上证综合ETF联接A",
          data3: "-2.43",
        },
        {
          data: "2",
          data1: "601398",
          data2: "国泰上证综合ETF联接C",
          data3: "0.85",
        },
        {
          data: "3",
          data1: "600036",
          data2: "富国上证综指ETF",
          data3: "0.53",
        },
        {
          data: "4",
          data1: "601288",
          data2: "汇添富上证综合指数",
          data3: "0.33",
        },
        {
          data: "5",
          data1: "601288",
          data2: "国泰上证综合ETF",
          data3: "0.33",
        },
      ],
      tableData2: [
        {
          date: "1",
          data1: "空调",
          data2: "+73.0%",
          data3: "+73.0%",
        },
        {
          date: "2",
          data1: "其他业务",
          data2: "--",
          data3: "2.14%",
        },
        {
          date: "3",
          data1: "小家电",
          data2: "--",
          data3: "0.22%",
        },
      ],
      tableData3: [
        {
          date: "市盈率",
          data1: "45.2",
          data2: "48.8",
          data3: "33.1",
        },
        {
          date: "净利润",
          data1: "522亿",
          data2: "613亿",
          data3: "712亿",
        },
        {
          date: "每股收益",
          data1: "41.5",
          data2: "48.8",
          data3: "56.7",
        },
        {
          date: "同比增长",
          data1: "11.7%",
          data2: "17.5%",
          data3: "16.2%",
        },
        {
          date: "PEG",
          data1: "2.99",
          data2: "2.55",
          data3: "2.19",
        },
      ],
      tableData4: [
        {
          date: "7.05%",
          data1: "6.92%",
          data2: "0.13%",
          data3: "0.05%",
          data4: "0%",
          data5: "0%",
        },
      ],
      tableData5: [
        {
          date: "1",
          data1: "中国贵州茅台酒厂(集团)有限责任公司",
          data2: "54.0%",
          data3: "0%",
        },
        {
          date: "2",
          data1: "香港中央结算有限公司(陆股通)",
          data2: "--",
          data3: "2.14%",
        },
        {
          date: "3",
          data1: "贵州省国有资本运营有限责任公司",
          data2: "--",
          data3: "0.22%",
        },
      ],
      headerStyle: {
        background: "red",
      },
      codes:"",    //指数代码
      real_time_data:{},   //指数基本信息
      intro:[],    //指数简介
      chart1_data_x:[], //k线图x轴数据
      chart1_data_y:[], //k线图y轴数据
      chart1_data_volumes:[], //k线图交易量
      indexRelationFundlist:[], //相关基金
      chart2_data_x : [],      //估值水平x轴数据
      chart2_data_y : [],       //估值水平y轴数据
      chart2_data_y2 : [],//估值水平y轴数据
      chart2_data_y3 : [],//估值水平y轴数据
      chart2_data_y4 : [],//估值水平y轴数据
      chart2_data_1:'', // 市盈率
      chart2_data_2:'', //市净率
      chart2_data_3:'', //市销率
      chart2_data_4:'', //市现率
      chart2_data_txt:'', //估值与分位文字
      chart3_data_x:[],   //PE/PB x轴数据
      chart3_data_y:[],   //PE/PB y轴数据
      chart3_data_y2:[],   //PE/PB y轴数据
      chart3_data_y3:[],   //PE/PB y轴数据
      chart3_data_y4:[],   //PE/PB y轴数据
      chart3_data_y5:[],   //PE/PB y轴数据
      chart3_data_y6:[],   //PE/PB y轴数据
      chart3_data_1:'',     //chart3val
      chart3_data_2:'', //chart3val
      chart3_data_3:'', //chart3val
      chart3_data_4:'', //chart3val
      chart3_data_5:'', //chart3val
      chart6_data_x:[],
      chart6_data_y:[],
      chart6_data_y2:[],
      chart6_data_table:[],
      chart16_data_x:[],
      chart16_data_y:[],
      chart16_data_1:'',
      chart6_data_1:'',
      chart6_data_2:'',
      chart6_data_3:'',
      chart7_data_x:[],
      chart7_data_y:[],
      chart7_data_y2:[],
      chart7_data_table:[],
    };
  },
  mounted(){
    let codes = this.$route.params.codes
    let codes2 = codes.slice(0,2)
    let codes3 = codes.slice(2,8)
    let canshu2 = `${codes3}.${codes2}`
    this.codes = canshu2

    this.init_info()
    this.initindexComponent()
    this.initK()
    this.initindexRelationFund()
    this.initindexValuation()
    this.initindexPePbBand()
    this.initindexCapitalReturn()
    this.initindexDividendRate()
    this.initindexProfitMargin()
  },
  methods: {
    initindexProfitMargin(){
      let codes = this.codes
      let type 
      if(this.bxjj_navigation6 == 0){
        type = 'ths_gross_selling_rate_index'
      }else if(this.bxjj_navigation6 == 1){
        type = 'ths_net_sales_rate_index'
      }else if(this.bxjj_navigation6 == 2){
        type = 'ths_op_to_revenue_index'
      }
      let params = Object.assign({},{codes,type})
      indexProfitMargin(params).then((res)=>{
        let data = res.data.list
        this.chart7_data_x = []
        this.chart7_data_y = []
        this.chart7_data_y2 = []
        this.chart7_data_table = []
        data.map((ele)=>{
          this.chart7_data_x.push(ele.year)
          this.chart7_data_y.push(ele.avg)
          this.chart7_data_y2.push(ele.center)
          this.chart7_data_table.push({
            data1:ele.year,
            data2:ele.center,
            data3:ele.avg,
          })
        })
        setTimeout(() => {
          console.log(this.chart7_data_table);
         this.$refs.chart7.myEcharts7()
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initindexDividendRate(){
      let codes = this.codes
      indexDividendRate({codes}).then((res)=>{
        let data = res.data.list
        this.chart16_data_x = []
        this.chart16_data_y = []
        data.map((ele)=>{
          this.chart16_data_x.push(ele.trading_day)
          this.chart16_data_y.push(ele.ths_dividend_rate_index)
          return ele
        })
        this.chart16_data_1 = this.chart16_data_y[this.chart16_data_y.length - 1]
        setTimeout(() => {
         this.$refs.chart16.myEcharts16()
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initindexCapitalReturn(){
      let codes = this.codes
      let type
      if(this.bxjj_navigation5 == 0){
        type = 'ths_roe_ttm_index'
      }else if(this.bxjj_navigation5 == 1){
        type = 'ths_roic_index'
      }else if(this.bxjj_navigation5 == 2){
        type = 'ths_net_interest_of_ta_index'
      }
      let params = Object.assign({},{codes,type})
      indexCapitalReturn(params).then((res)=>{
        let data = res.data.list
        this.chart6_data_1 = res.data.latest_val.ths_roe_ttm_index
        this.chart6_data_2 = res.data.latest_val.ths_roic_index
        this.chart6_data_3 = res.data.latest_val.ths_net_interest_of_ta_index
        this.chart6_data_x = []
        this.chart6_data_y = []
        this.chart6_data_y2 = []
        this.chart6_data_table = []
          data.map((ele,index)=>{
            this.chart6_data_x.push(ele.year)
            this.chart6_data_y2.push(ele.center)
            this.chart6_data_y.push(ele.avg)
            this.chart6_data_table.push({
              data1:ele.year,
              data2:ele.center,
              data3:ele.avg,
            })
          })
        
        setTimeout(() => {
         this.$refs.chart6.myEcharts6() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initindexPePbBand(){
      let codes = this.codes
      let type
      if(this.bxjj_navigation3 == 0){
        type = 'ths_pe_ttm_index'
      }else if(this.bxjj_navigation3 == 1){
        type = 'ths_pb_index'
      }else if(this.bxjj_navigation3 == 2){
        type = 'ths_ps_ttm_index'
      }else if(this.bxjj_navigation3 == 3){
        type = 'ths_pcf_ttm_index'
      }else{
        this.$message.error('!!!')
        return
      }
      let params = Object.assign({},{codes,type})
      indexPePbBand(params).then((res)=>{
        let data = res.data.list
        this.chart3_data_1 = res.data.val1
        this.chart3_data_2 = res.data.val2
        this.chart3_data_3 = res.data.val3
        this.chart3_data_4 = res.data.val4
        this.chart3_data_5 = res.data.val5
        this.chart3_data_x = []
        this.chart3_data_y = []
        this.chart3_data_y2 = []
        this.chart3_data_y3 = []
        this.chart3_data_y4 = []
        this.chart5_data_y5 = []
        this.chart6_data_y6 = []
        data.map((ele)=>{
          this.chart3_data_x.push(ele.update_time)
          this.chart3_data_y.push(ele.ths_close_price_index)
          this.chart3_data_y2.push(ele.val1)
          this.chart3_data_y3.push(ele.val2)
          this.chart3_data_y4.push(ele.val3)
          this.chart3_data_y5.push(ele.val4)
          this.chart3_data_y6.push(ele.val5)
          return ele
        })

        setTimeout(() => {
         this.$refs.chart3.myEcharts3() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initindexValuation(){
      let codes = this.codes
      let type 
      if(this.bxjj_navigation2 == 0){
        type = 'ths_pe_ttm_index'
      }else if(this.bxjj_navigation2 == 1){
        type = 'ths_pb_index'
      }else if(this.bxjj_navigation2 == 2){
        type = 'ths_ps_ttm_index'
      }else if(this.bxjj_navigation2 == 3){
        type = 'ths_pcf_ttm_index'
      }else{
        this.$message.error('!!!')
        return
      }
      let params = Object.assign({},{codes,type})
      indexValuation(params).then((res)=>{
        let data = res.data.list
        this.chart2_data_1 = res.data.latest_val.ths_pe_ttm_index
        this.chart2_data_2 = res.data.latest_val.ths_pb_index
        this.chart2_data_3 = res.data.latest_val.ths_ps_ttm_index
        this.chart2_data_4 = res.data.latest_val.ths_pcf_ttm_index
        this.chart2_data_txt = res.data.txt
        this.chart2_data_x = []
        this.chart2_data_y = []
        this.chart2_data_y2 = []
        this.chart2_data_y3 = []
        this.chart2_data_y4 = []
        data.map((ele)=>{
          this.chart2_data_x.push(ele.update_time)
          if(this.bxjj_navigation2 == 0){
            this.chart2_data_y.push(ele.ths_pe_ttm_index)
          }else if(this.bxjj_navigation2 == 1){
            this.chart2_data_y.push(ele.ths_pb_index)
          }else if(this.bxjj_navigation2 == 2){
            this.chart2_data_y.push(ele.ths_ps_ttm_index)
          }else if(this.bxjj_navigation2 == 3){
            this.chart2_data_y.push(ele.ths_pcf_ttm_index)
          }
          this.chart2_data_y2.push(ele.min)
          this.chart2_data_y3.push(ele.center)
          this.chart2_data_y4.push(ele.max)
          return ele
        })
        setTimeout(() => {
         this.$refs.chart2.myEcharts2() 
        });
      })
    },
    initindexRelationFund(){
      let codes = this.codes
      indexRelationFund({codes}).then((res)=>{
        this.indexRelationFundlist = res.data.list
      }).catch((err)=>{
        console.log(err);
      })
    },
    init_info(){
      let codes = this.codes
      plateIndexDetail({codes}).then((res)=>{
        this.real_time_data = res.data.real_time_data
        this.intro = res.data.intro

      }).catch((err)=>{
        console.log(err);
      })
    },
    initindexComponent(){
      let codes = this.codes
      indexComponentList({codes}).then((res)=>{

        this.tableData = res.data.list.slice(0,5)
      }).catch((err)=>{
        console.log(err);
      })
    },
    initK(){
      Kline().then((res)=>{

        let a = res.data
        let _canshu = []
        let _canshu1 = []
        let _canshu2 = []
        a.map((ele)=>{
          let arr0 = ele.TradingDay
          let arr = [ele.OpenPrice,ele.ClosePrice,ele.LowPrice,ele.HighPrice,ele.TurnoverVolume]
          let arr2 = ele.TurnoverVolume
          _canshu.push(arr0)
          _canshu1.push(arr)
          _canshu2.push(arr2)
          return ele
        })
        this.chart1_data_x = _canshu
        this.chart1_data_y = _canshu1
        this.chart1_data_volumes = _canshu2
        setTimeout(() => {
         this.$refs.chart1.init() 
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    close_prame1() {
      this.frame1_show = false;
    },
    frame2_close() {
      this.frame2_show = false;
    },
    frame2_open() {
      this.frame2_show = true;
    },
    frame1_open() {
      this.frame1_show = true;
    },
    frame9_close() {
      this.frame9_show = false;
    },
    frame8_close() {
      this.frame8_show = false;
    },
    frame10_open() {
      this.frame10_show = true;
    },
    frame10_close() {
      this.frame10_show = false;
    },
    frame11_open() {
      this.frame11_show = true;
    },
    frame11_close() {
      this.frame11_show = false;
    },
    frame12_open() {
      this.frame12_show = true;
    },
    frame12_close() {
      this.frame12_show = false;
    },
    frame13_open() {
      this.frame13_show = true;
    },
    frame13_close() {
      this.frame13_show = false;
    },
    frame14_open() {
      this.frame14_show = true;
    },
    frame14_close() {
      this.frame14_show = false;
    },
    frame15_open() {
      this.frame15_show = true;
    },
    frame15_close() {
      this.frame15_show = false;
    },
    frame16_open() {
      this.frame16_show = true;
    },
    frame16_close() {
      this.frame16_show = false;
    },
    frame17_open() {
      this.frame17_show = true;
    },
    frame17_close() {
      this.frame17_show = false;
    },
    frame18_open() {
      this.frame18_show = true;
    },
    frame18_close() {
      this.frame18_show = false;
    },
    frame19_open() {
      this.frame19_show = true;
    },
    frame19_close() {
      this.frame19_show = false;
    },
    frame20_open() {
      this.frame20_show = true;
    },
    frame20_close() {
      this.frame20_show = false;
    },
    frame21_open() {
      this.frame21_show = true;
    },
    frame21_close() {
      this.frame21_show = false;
    },
    change_change_option(e) {
      this.change_option = e;
    },
    change_top_button(e) {
      this.bxjj_navigation = e;
    },
    change_top_button2(e) {
      this.bxjj_navigation2 = e;
      this.initindexValuation()
    },
    change_top_button3(e) {
      this.bxjj_navigation3 = e;
      this.initindexPePbBand()
    },
    change_top_button4(e) {
      this.bxjj_navigation4 = e;
    },
    change_top_button5(e) {
      this.bxjj_navigation5 = e;
      this.initindexCapitalReturn()
    },
    change_top_button6(e) {
      this.bxjj_navigation6 = e;
      this.initindexProfitMargin()
    },
    change_top_button7(e) {
      this.bxjj_navigation7 = e;
    },
    change_top_button8(e) {
      this.bxjj_navigation8 = e;
    },
    change_top_button9(e) {
      this.bxjj_navigation9 = e;
    },
    change_top_button10(e) {
      this.bxjj_navigation10 = e;
    },
    ckqw(e) {
      console.log(e);
    },
    gotosharesinfo(e){
      let canshu = Object.assign({},{codes:e})
      let codes2 = canshu.codes.slice(0,6)
      let codes3 = canshu.codes.slice(7)
      let canshu2 = `${codes3}${codes2}.html`
      // this.$router.push({path:`/I/${canshu2}`})
      this.$router.push({path:`/stock/${canshu2}`})
    }
  },
  components: {
    Chart1,
    Chart2,
    Chart3,
    Chart6,
    Chart7,
    Chart16,
    Chart18,
    Frame1,
    Frame2,
    Frame3,
    Frame4,
    Frame5,
    Frame6,
    Frame7,
    Frame8,
    Frame9,
    Frame10,
    Frame11,
    Frame12,
    Frame13,
    Frame14,
    Frame15,
    Frame16,
    Frame17,
    Frame18,
    Frame19,
    Frame20,
    Frame21,
  },
};
</script>

<style scoped>
.index_Info {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  height: 109px;
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.box2 {
  width: calc(100% - 48px);
  height: 390px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
}
.box3 {
  width: calc(100% - 48px);
  /* height: 82px; */
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box3_top {
  display: flex;
  justify-content: space-between;
}
.box3_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box3_text1 img {
  width: 48px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 10px;
}
.box3_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box3_text2 img {
  width: 17px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 5px;
}

.box4 {
  width: calc(100% - 48px);
  /* height: 82px; */
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box4_top {
  display: flex;
  justify-content: space-between;
}
.box4_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box4_text1 img {
  width: 48px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 10px;
}
.box4_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box4_text2 img {
  width: 17px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 5px;
}

.box5 {
  width: calc(100% - 48px);
  /* height: 417px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box6 {
  width: calc(100% - 48px);
  height: 480px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box7 {
  width: calc(100% - 48px);
  height: 480px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box8 {
  width: calc(100% - 48px);
  /* height: 615px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box9 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box10 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box11 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box12 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box13 {
  width: calc(100% - 48px);
  height: 800px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box14 {
  width: calc(100% - 48px);
  height: 560px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box15 {
  width: calc(100% - 48px);
  /* height: 378px; */
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box16 {
  width: calc(100% - 48px);
  height: 500px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box17 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box18 {
  width: calc(100% - 48px);
  height: 355px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box19 {
  width: calc(100% - 48px);
  height: 466px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box20 {
  width: calc(100% - 48px);
  height: 370px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box21 {
  width: calc(100% - 48px);
  height: 406px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box22 {
  width: calc(100% - 48px);
  height: 406px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box23 {
  width: calc(100% - 48px);
  height: 180px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box24 {
  width: calc(100% - 48px);
  height: 320px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box25 {
  width: calc(100% - 48px);
  height: 320px;
  padding: 24px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* display: flex; */
  margin-top: 24px;
  position: relative;
}
.box1_left {
  display: flex;
  flex-direction: column;
}
.box1_left_top {
  display: flex;
  align-content: center;
  line-height: 24px;
}
.box1_left_top_text1 {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}
.box1_left_top_text2 {
  font-size: 18px;
  color: #000000;
  margin-left: 10px;
}
.box1_left_top_text3 {
  width: 64px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text4 {
  width: 54px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text5 {
  font-size: 12px;
  margin-left: 20px;
  color: #000000;
}
.box1_left_bottom {
  display: flex;
  margin-top: 18px;
}
.box1_left_bottom_left {
  display: flex;
  flex-direction: column;
  padding-right: 24px;
  border-right: 1px solid #ebebeb;
}
.box1_left_bottom_left_text1 {
  font-size: 30px;
  color: #47ba74;
}
.box1_left_bottom_left_text2 {
  color: #47ba74;
  font-size: 18px;
}
.box1_left_bottom_right {
  margin-left: 30px;
  display: flex;
}
.box1_left_bottom_right_group1 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 15px;
  color: #333;
}
.box1_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  /* padding-left: 40px; */
}
.box1_right_top {
  width: 176px;
  height: 30px;
  background-color: #fcad2a;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.box1_right_bottom {
  display: flex;
  margin-top: 12px;
}
.box1_right_bottom_left {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  cursor: pointer;
}
.box1_right_bottom_right {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  margin-left: 6px;
  cursor: pointer;
}
.box2_top_button {
  height: 24px;
  display: flex;
  margin-bottom: 25px;
}
.box2_top_button_text1 {
  font-size: 18px;
  color: #666666;
  cursor: pointer;
  margin-left: 24px;
}
.box2_top_button_text1:nth-child(1) {
  margin-left: 0px;
}
.box2_top_button_text2 {
  color: #000000;
  font-weight: bold;
  position: relative;
}
.box2_top_button_text2::after {
  content: " ";
  display: block;
  width: 36px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -6px;
  left: calc(50% - 18px);
}
.box5_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
.box5_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 25px;
}
.box5_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box5_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box5_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box5_table_centent_text1 {
  font-size: 16px;
  color: #333333;
}
.box5_table_centent_text2 {
  font-size: 14px;
  color: #666666;
}
.box5_table_cz {
  text-align: center;
  color: #fcad2a;
  cursor: pointer;
}
.box5_bottom {
  width: 100%;
  font-size: 16px;
  color: #333333;
  /* position: absolute; */
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
}
.box5_bottom img {
  width: 14px;
  margin-left: 5px;
}

.el-table /deep/ th {
  background-color: #f8f9fd !important;
  text-align: center;
  height: 56px;
}
.el-table /deep/ td {
  height: 56px;
}

.box6_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box6_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box6_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box6_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box6_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box6_top_tip {
  font-size: 14px;
  color: #333333;
}

.box6_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box6_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box6_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box6_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box6_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box6_top_legend_box_option3_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box7_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box7_top_title_text1 {
}
.box7_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box7_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box7_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box7_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box7_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box7_top_tip {
  font-size: 14px;
  color: #333333;
}
.box7_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box7_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box7_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box7_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option3_colordiv {
  background-color: #00CBFF;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option4_colordiv {
  background-color: #3D81FF;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option5_colordiv {
  background-color: #A043F5;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box7_top_legend_box_option6_colordiv {
  background-color: #FD95BB;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box8_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box8_top_title_text1 {
}
.box8_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box8_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box8_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box8_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box8_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box8_top_tip {
  font-size: 14px;
  color: #333333;
}
.box8_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box8_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box8_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box8_top_legend_box_option1_colordiv {
  background-color: rgba(252, 173, 42, 0.4);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option2_colordiv {
  background-color: rgba(252, 173, 42, 0.6);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option3_colordiv {
  background-color: rgba(252, 173, 42, 0.8);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option4_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box8_top_legend_box_option5_colordiv {
  background-color: #579eff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box9_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box9_top_title_text1 {
}
.box9_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box9_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box9_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box9_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box9_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box9_top_legend_box_option2_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box10_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box10_top_title_text1 {
}
.box10_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box10_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box10_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box10_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box10_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box10_top_tip {
  font-size: 14px;
  color: #333333;
}
.box10_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box10_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box10_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box10_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box10_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box11_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box11_top_title_text1 {
}
.box11_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box11_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box11_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box11_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box11_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box11_top_tip {
  font-size: 14px;
  color: #333333;
}
.box11_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box11_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box11_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box11_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box11_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box12_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box12_top_title_text1 {
}
.box12_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box12_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box12_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box12_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box12_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box12_top_tip {
  font-size: 14px;
  color: #333333;
}
.box12_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box12_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box12_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box12_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box12_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box13_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box13_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box13_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box13_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box13_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box13_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option3_colordiv {
  background-color: rgba(252, 173, 42, 1);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option4_colordiv {
  background-color: rgba(252, 173, 42, 0.8);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option5_colordiv {
  background-color: rgba(252, 173, 42, 0.6);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_legend_box_option6_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box13_top_tip1 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box13_top_tip2 {
  font-size: 14px;
  color: #333333;
}
.i1 {
  font-style: normal;
  color: #fd4c4c;
}
.box13_technological_process {
  margin-top: 30px;
  /* float: right; */
  display: flex;
  width: 1405px;
  min-width: 1405px;
  justify-content: space-between;
}
.box13_technological_process_box1 {
  width: 292px;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0px 1px 11px 1px rgba(220, 220, 220, 0.4);
  border-radius: 10px;
  padding: 21px 19px 16px 17px;
}
.box13_technological_process_box1_title {
  font-size: 14px;
  color: #333333;
}
.box13_technological_process_box1_bootom_option1_jindu {
  display: flex;
  align-content: center;
  margin-top: 10px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu1 {
  width: 28px;
  height: 0;
  border-bottom: 1px solid #bfbfbf;
  margin-top: 7px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu12 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu2 {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #bfbfbf;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu22 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu3 {
  width: 28px;
  height: 0;
  border-bottom: 1px solid #bfbfbf;
  margin-top: 7px;
}
.box13_technological_process_box1_bootom_option1_jindu_jindu32 {
  border-color: #fcad2a;
}
.box13_technological_process_box1_bootom_option1_text1 {
  color: #333;
  font-size: 14px;
  margin-top: 5px;
}
.box13_technological_process_box1_bootom_option1_text2 {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.box13_technological_process_box1_bootom_option1 {
  width: 73px;
  text-align: center;
}
.box13_technological_process_box1_bootom {
  display: flex;
}

.box13_fyq {
  text-align: right;
  margin-top: 17px;
  float: right;
}
.box13_fyq
  /deep/.el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #fcad2a;
  /* color: #fff; */
}
.box13_top_tip3 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box13_top_tip4 {
  font-size: 14px;
  color: #333333;
}

.box14_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box14_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box14_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box14_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box14_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box14_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box14_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box14_top_legend_box_option3_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box14_top_tip1 {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box14_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box14_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box14_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box14_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}

.box15_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box15_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box15_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box15_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box15_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box15_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}

.box16_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box16_top_title_text1 {
}
.box16_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box16_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box16_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box16_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box16_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box16_top_tip {
  font-size: 14px;
  color: #333333;
}
.box16_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box16_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box16_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box16_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box16_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box17_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box17_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box17_top_tip1 {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}

.box18_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box18_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box18_top_tip1 {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #333333;
  padding-left: 10px;
}
.box18_top_legend_box {
  display: flex;
  /* margin-top: 20px; */
}
.box18_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box18_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box18_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box18_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box18_top_legend_box_option3_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box19_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box19_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box19_bottom {
  margin-top: 20px;
}

.box20_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box20_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box20_top_button {
  display: flex;
  align-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.box20_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box20_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box20_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box20_top_legend_box {
  display: flex;
  /* margin-top: 20px; */
}
.box20_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box20_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box20_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box20_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box21_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box21_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box21_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box21_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box21_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box21_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box21_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box22_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}

.box22_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  /* opacity: 0.06; */
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}

.box22_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box22_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box22_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box22_top_legend_box_option1_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box22_top_legend_box_option2_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box23_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box23_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box23_bottom {
  margin-top: 20px;
}

.box24_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box24_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box24_bottom {
  margin-top: 20px;
}

.box25_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  display: flex;
}
.box25_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.tuceng {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
}
.box3_content {
  margin-bottom: 35px;
}
.box3_content_options1 {
  display: flex;
}
.box3_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(253, 76, 76, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #fd4c4c;
  text-align: center;
}
.box3_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.box4_content {
  margin-bottom: 35px;
}

.box4_content_options1 {
  display: flex;
}
.box4_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(83, 156, 255, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #539cff;
  text-align: center;
}
.box4_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.margin_top18 {
  margin-top: 18px;
}
.box15_bottom_top_title {
  width: 65px;
  height: 16px;
  font-size: 16px;
  color: #333333;
  position: relative;
  z-index: 5;
}
.box15_bottom_top_title::after {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#fd4c4c, #fd4c4c);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 16px 2px rgba(252, 173, 42, 0.13);
  border-radius: 1px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -4px;
  left: calc(50% - 30px);
  z-index: -4;
}
.box15_bottom_top {
  display: flex;
}
.box15_bottom_top_text img {
  width: 10px;
  height: 13px;
  margin-right: 3px;
}
i{
  font-style: normal;
}
.box25_legend{
  display: flex;
  font-size: 14px;
  color: #333333;
  margin-top: 24px;
}
.box25_legend_box1{
  margin-left: 30px;
}
.box25_legend_box1:nth-child(1){
  margin-left: 15px;
}
.color_red{
  color: #fd4c4c;
}
.color_green{
  color: #47ba74;
}
</style>